export default __webpack_public_path__ + "static/icon_head-e54ee32538b6333c5b317fd3c2e679d1.png";